export class Globals {
  static importUpload = false;
}
